export const USER_FEATURES_CACHE_KEY = "uf"; // User Features
export const FIREBASE_REMOTE_CONFIG_FEATURES_CACHE_KEY = "frc";
